"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var typesafe_actions_1 = require("typesafe-actions");
var redux_1 = require("redux");
var reselect_1 = require("reselect");
tslib_1.__exportStar(require("redux-actions"), exports);
var redux_actions_1 = require("redux-actions"); // @fix ts2742 in createModel.ts by export * from 'redux-actions'
exports.handleActions = redux_actions_1.handleActions;
exports.createAction = typesafe_actions_1.action;
exports.bindActionCreators = reselect_1.createSelector([function (actions, dispatch) { return actions; }, function (actions, dispatch) { return dispatch; }], function (actions, dispatch) { return redux_1.bindActionCreators(actions, dispatch); });
//# sourceMappingURL=actions.js.map